import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule }               from '../shared/shared.module';
import { StockTakeQuickAddComponent } from './stock-take.quick-add.component';
import { StockTakeService }           from './stock-take.service';

@NgModule({
  declarations: [
    StockTakeQuickAddComponent
  ],
  entryComponents: [
    StockTakeQuickAddComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    StockTakeService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class StockTakeModule {}
